//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

import { OperatorValue } from 'components/inputs/types';
import DataUrlConstants from 'utils/DataUrlConstants';
import { makeUrl } from 'utils/UrlUtil';

import { injectEndpoints } from '../api';
import { PicklistAdditionalNodeConfig, PicklistAdditionalNodeConfigParams } from './types';

const picklistApi = injectEndpoints({
  endpoints: (builder) => ({
    getAdditionalConfig: builder.query<PicklistAdditionalNodeConfig, PicklistAdditionalNodeConfigParams>({
      query: (configParams) => ({
        url: DataUrlConstants.NODE_CONFIG_ADDITIONAL_CONFIG,
        method: 'POST',
        body: configParams,
      }),
    }),
    getOperatorsForDataType: builder.query<OperatorValue[], { dataType: string }>({
      query: ({ dataType }) => ({
        url: makeUrl(DataUrlConstants.GET_PICKLIST_OPERATORS, {}, { dataType }),
      }),
    }),
  }),
});

export const {
  useLazyGetAdditionalConfigQuery,
  util: pipelineErrorApiUtil,
  useGetOperatorsForDataTypeQuery,
} = picklistApi;
